import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium" }, " Estudiante ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "inputRep",
  class: "form-label fw-medium text-black"
}, "Año académico", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "inputRep",
  class: "form-label fw-medium text-black"
}, "Sede", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "inputRep",
  class: "form-label fw-medium text-black"
}, "Grupo asignado", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium" }, "Período", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium d-block" }, "Estado", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium" }, "Descripción general", -1)
const _hoisted_8 = { class: "col-md-12 mt-2" }
const _hoisted_9 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, "Cancelar", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchSelect = _resolveComponent("SearchSelect")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_b_form_textarea = _resolveComponent("b-form-textarea")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_b_form, {
      ref: "formRecord",
      id: "formModal",
      onSubmit: _withModifiers(_ctx.save, ["prevent"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_group, null, {
                  default: _withCtx(() => [
                    _hoisted_1,
                    _createVNode(_component_SearchSelect, {
                      modelValue: _ctx.form.record.StudentId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.record.StudentId) = $event)),
                      loading: _ctx.loading,
                      onChange: _ctx.changeValuesLoad,
                      disabled: _ctx.form.record.Id > 0,
                      options: _ctx.students.map((s) => ({
                                value: s.Id,
                                text: `${s.IdentificationNumber} - ${s.Name} ${s.LastName}`,
                            }))
                                ,
                      placeholder: "Seleccione un estudiante"
                    }, null, 8, ["modelValue", "loading", "onChange", "disabled", "options"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_b_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_group, null, {
                  default: _withCtx(() => [
                    _hoisted_2,
                    _createVNode(_component_SearchSelect, {
                      modelValue: _ctx.form.record.AcademicYearId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.record.AcademicYearId) = $event)),
                      required: "",
                      loading: _ctx.form.loading,
                      disabled: "",
                      options: _ctx.academicYears.map(r => ({ value: r.Id, text: `Año ${r.Year} - Período: ${r.StartDate.substring(0, 10)} Hasta ${r.EndDate.substring(0, 10)}` })),
                      placeholder: "Seleccione el año académico",
                      onChange: _ctx.changeValuesLoad
                    }, null, 8, ["modelValue", "loading", "options", "onChange"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_group, null, {
                  default: _withCtx(() => [
                    _hoisted_3,
                    _createVNode(_component_SearchSelect, {
                      modelValue: _ctx.form.record.HeadquarterId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.record.HeadquarterId) = $event)),
                      required: "",
                      loading: _ctx.form.loading,
                      disabled: "",
                      options: _ctx.headquarters.map(r => ({ value: r.Id, text: `${r.Description}` })),
                      placeholder: "Seleccione la sede",
                      onChange: _ctx.changeValuesLoad
                    }, null, 8, ["modelValue", "loading", "options", "onChange"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_b_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_group, null, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _createVNode(_component_SearchSelect, {
                      modelValue: _ctx.form.record.CourseGroupId,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.record.CourseGroupId) = $event)),
                      required: "",
                      loading: _ctx.form.loading,
                      disabled: "",
                      options: _ctx.courseGroups.map(r => ({ value: r.Id, text: r.Name })),
                      placeholder: "Seleccione el grupo"
                    }, null, 8, ["modelValue", "loading", "options"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_group, null, {
                  default: _withCtx(() => [
                    _hoisted_5,
                    _createVNode(_component_SearchSelect, {
                      modelValue: _ctx.form.record.PeriodId,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.record.PeriodId) = $event)),
                      loading: _ctx.loading,
                      options: _ctx.periods.map((p) => ({
                            value: p.Id,
                            text: `${p.Description} / Desde: ${p.DateFrom.substring(0, 10)} Hasta: ${p.DateTo.substring(0, 10)}`

                        }))
                            ,
                      placeholder: "Seleccione el período"
                    }, null, 8, ["modelValue", "loading", "options"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_b_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_group, null, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    _createVNode(_component_b_form_checkbox, {
                      modelValue: _ctx.form.record.Status,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.record.Status) = $event)),
                      value: 1,
                      "unchecked-value": 0
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Activo ")
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_group, null, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _createVNode(_component_b_form_textarea, {
                      modelValue: _ctx.form.record.GeneralDescription,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.record.GeneralDescription) = $event)),
                      rows: "3",
                      size: "sm",
                      placeholder: "Descripción general del PIAR, barreras identificadas, observaciones, etc."
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_b_button, {
              class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
              type: "submit",
              disabled: _ctx.saving
            }, {
              default: _withCtx(() => [
                (_ctx.form.record.Id)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Guardar cambios"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_11, "Crear PIAR"))
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_b_button, {
              onClick: _ctx.cancel,
              class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
            }, {
              default: _withCtx(() => [
                _hoisted_12,
                _hoisted_13
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ]))
}